const LOCATIONIQ_API_KEY = import.meta.env.VITE_LOCATIONIQ_API_KEY;

export const searchAddresses = async (query, country) => {
  if (!query || query.length < 2) return [];

  try {
    if (!LOCATIONIQ_API_KEY) {
      return [];
    }

    const response = await fetch(
      `https://api.locationiq.com/v1/autocomplete?key=${LOCATIONIQ_API_KEY}&q=${encodeURIComponent(query)}&limit=5${country ? `&countrycodes=${country}` : ''}&dedupe=1&format=json`
    );
    
    if (!response.ok) {
      return [];
    }
    
    const data = await response.json();
    
    if (!Array.isArray(data) || data.length === 0) {
      return [];
    }

    return data.map(item => ({
      id: item.place_id,
      address: item.display_place || item.display_name,
      fullAddress: item.display_name,
      lat: item.lat,
      lon: item.lon,
      city: item.address?.city || '',
      state: item.address?.state || '',
      country: item.address?.country || '',
      postcode: item.address?.postcode || ''
    }));
  } catch (error) {
    return [];
  }
}; 